import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "October",
  "description": "",
  "published": "2006-10-17T00:00:00.000Z",
  "redirect_from": ["/blog/october/swizec/378"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`About time this blog got updated don't you think? Alas, though, there isn't much to be told as everything has been rather uneventful and all the blind fits of rage over matters worth ranting and raving about have long but passed and subsided without being blogged about.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "http://swizec.com//index.php/mode=pages/submode=Links"
      }}>{`links`}</a>{` page has gotten a bit of a facelift and should prove better now. There are plans to add some more links to it where the authors don't provide linking banners of their own, but seeing as taht's a tad more work to be done it hasn't gotten done yet.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/05_prev.jpg",
        "alt": null
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com//index.php/mode=show_comics/comic=4"
      }}>{`Cthulhu`}</a>{` has gotten a bit of an update for October, which is quite good because it got done smack in the middle of the month and that means it was almost exactly on schedule.`}</p>
    <p>{`Which brings us to the next point on the agenda. You might notice that under the comic page it says the next one is to be upon you in December and not November as one woudl naturally assume. This has to be so because of some very amasingly awesome event that is to be going on all November, but I'll leave the details for the next blog post, some of you may already mostly know them, most probably not, but hey, that's what cliffhangers are for.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      